<div class="td-cnt-ext" [style.top.px]="topPx">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialogItem">
        <div class="td-cnt-title">
            <div>
                <i *ngIf="dialogIcon != ''" class="{{dialogIcon}} dialog-icon"></i>
                <span class="te-title">{{title}}</span>
            </div>
            <!-- {{marketingRoute}} - {{millChangedByUser}} -->
            <span *ngIf="odMillRuleActive()">
                <i class="fas fa-play-circle dialog-icon" style="color:#ff6600"></i>
            </span>
        </div>
        <div class="td-cnt-body"> <!--  [ngClass]="{'flex-col': display == 'column'}" -->
            <!--             <teiasoft-breadcrumb [dataSet]="items" [columnToShow]="'itemNo'" [activeIndex]="selectedIndexItem"
                (tbcClick)="tbcClick($event)" style="width:100%"></teiasoft-breadcrumb> -->
            <div class="td-cnt-form">
                <div class="grid-container">
                    <!-- GENERAL -->
                    <!-- <div class="dialog-row"> -->
                    <teiasoft-input class="grid-item" [labelText]="'grid.CustomerItemNo' | translate"
                        [value]="customerItemNoValue" [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                        [isValid]="customerItemNoIsValid" [readOnly]="false" (onInput)="onInputCustomerItemNo($event)"
                        [maxLength]="5"></teiasoft-input>



                    <!-- <teiasoft-select [emitOnDefaultInit]="false" class="grid-item" [labelText]="'enquiryBook.UnitSystem' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="true" [optionsList]="unitSystemOptionList"
                        [spaceLabel]="true" [noMinWidth]="false" [isValid]="unitSystemIsValid"
                        [defaultValue]="unitSystemValue" (onSelected)="onSelecteUnitSystem($event)" [tabIndex]="0"
                        [readOnly]="false"></teiasoft-select> -->


                    <teiasoft-input class="grid-item" [type]="'text'" [labelText]="'grid.MaterialCode' | translate"
                        [isMobile]="isMobile" [isRequired]="materialIsRequired" [disabled]="materialDisabled"
                        [value]="materialValue" [showCreate]="false" [autoComplete]="true"
                        [autoCompleteDataset]="materialDataset" [autoCompleteColumns]="['materialCode']"
                        [autoCompleteField]="'materialCode'" [columnsWidthPerc]="[100]" [isValid]="materialIsValid"
                        [allowSingleSelectionClear]="true" (onAutocompleteSelect)="onAutocompleteSelect($event)"
                        (onAutocompleteInputChange)="onAutocompleteInputChange($event)"
                        (onAutocompleteRemoveElement)="onAutocompleteRemoveElement($event)"
                        [readOnly]="false"></teiasoft-input>
                    <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                        [labelText]="'enquiryBook.smsMarketingRoute' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [optionsList]="smsMarketingRouteOptionList!"
                        [spaceLabel]="true" [noMinWidth]="false" [isValid]="smsMarketingRouteIsValid"
                        [defaultValue]="smsMarketingRouteValue" (onSelected)="onSelectedMarketingRouteSms($event)"
                        [readOnly]="false"></teiasoft-select>

                    <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                        [labelText]="'enquiryBook.sms' | translate" [isMobile]="isMobile" [isRequired]="true"
                        [disabled]="false" [optionsList]="smsOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="smsIsValid" [defaultValue]="smsValue" (onSelected)="onSelectedSms($event)"
                        [readOnly]="false" ></teiasoft-select>

                    <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                        [labelText]="'grid.MarketFamily' | translate" [isMobile]="isMobile" [isRequired]="true"
                        [disabled]="false" [optionsList]="marketFamilyOptionList!" [spaceLabel]="true"
                        [noMinWidth]="false" [isValid]="marketFamilyIsValid" [defaultValue]="marketFamilyValue"
                        (onSelected)="onSelectedMarketFamily($event)" [readOnly]="false"></teiasoft-select>

                    <teiasoft-datetime class="grid-item" [value]="customerDeliveryDateValue"
                        [labelText]="'grid.CustomerDeliveryDate' | translate" [type]="'date'" [isRequired]="false"
                        [disabled]="false" [isMobile]="isMobile" [isValid]="customerDeliveryDateIsValid"
                        (onChange)="onChangeCustomerDeliveryDate($event)"
                        [dateFormat]="globals!.dateFormat!"></teiasoft-datetime>

                    <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.OfferScheme' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                        [optionsList]="offerSchemeOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="offerSchemeIsValid" [defaultValue]="offerSchemeValue"
                        (onSelected)="onSelectedOfferScheme($event)" [readOnly]="false"></teiasoft-select>

                    <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                        [labelText]="'grid.EnergySurcharge' | translate" [isMobile]="isMobile" [isRequired]="true"
                        [disabled]="false" [optionsList]="energySurchargeOptionList!" [spaceLabel]="true"
                        [noMinWidth]="false" [isValid]="energySurchargeIsValid" [defaultValue]="energySurchargeValue"
                        (onSelected)="onSelectedEnergySurcharge($event)" [readOnly]="false"></teiasoft-select>

                    <!-- </div> -->
                    <!-- NORM / GRADES -->
                    <!-- <div class="dialog-row"> -->
                    <teiasoft-input class="grid-item" [type]="'text'"
                        [labelText]="'enquiryBook.applicableNorms' | translate" [isMobile]="isMobile"
                        [isRequired]="false" [disabled]="false" [value]="applicableNormsValue"
                        (onInput)="onInputApplicableNorms($event)" [readOnly]="false"></teiasoft-input>
                    <teiasoft-input class="grid-item span-2" [type]="'text'" [labelText]="'grid.NormGrades' | translate"
                        [isMobile]="isMobile" [isRequired]="normGradesIsrequired" [disabled]="false"
                        [value]="normGradesCodes" [showCreate]="false" [autoComplete]="true"
                        [autoCompleteDataset]="normGradesDataset" [autoCompleteColumns]="columnsNormGrades"
                        [autoCompleteColumnsToHide]="columnsToHideNormGrades" [autoCompleteField]="'normGrades'"
                        [columnsWidthPerc]="[100]" [isValid]="normGradeIsValid" [multiSelection]="true"
                        (onAutocompleteInputChange)="onAutocompleteInputChange($event)"
                        (onAutocompleteSelectRows)="onAutocompleteSelectRows($event)"
                        (onAutocompleteRemoveElement)="onAutocompleteRemoveElement($event)"
                        [readOnly]="false"></teiasoft-input>

                    <teiasoft-select [emitOnDefaultInit]="false" *ngIf="!analysisLimitationFreeInput"
                        [labelText]="'enquiryBook.analysisLimitation' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [optionsList]="analysisLimitationOptionList!"
                        [spaceLabel]="true"
                        [disabled]="!normGradesCodes || normGradesCodes.length == 0 || !analysisLimitationOptionList || analysisLimitationOptionList.length == 0"
                        [noMinWidth]="false" [isValid]="analysisLimitationIsValid"
                        [defaultValue]="analysisLimitationValue" (onSelected)="onSelectedAnalysisLimitation($event)"
                        [readOnly]="false"></teiasoft-select>
                    <teiasoft-input *ngIf="analysisLimitationFreeInput" [type]="'text'"
                        [labelText]="'enquiryBook.analysisLimitation' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [value]="analysisLimitationValue" [noMinWidth]="false"
                        (onInput)="onInputAnalysisLimitation($event)" [isValid]="analysisLimitationIsValid"
                        [disabled]="!normGradesCodes || normGradesCodes.length == 0" [readOnly]="false"
                        [maxLength]="200"></teiasoft-input>
                    <div class="chk-cnt">
                        <i *ngIf="!analysisLimitationFreeInput && (normGradesCodes && normGradesCodes.length > 0)"
                            class="fal fa-square chk-limitation" (click)="onCheckAnalysisLimitation()"></i>
                        <i *ngIf="analysisLimitationFreeInput && (normGradesCodes && normGradesCodes.length > 0)"
                            class="fas fa-check-square chk-limitation" (click)="onCheckAnalysisLimitation()"></i>
                        <i *ngIf="!normGradesCodes || normGradesCodes.length == 0"
                            class="fal fa-square chk-disabled"></i>
                        <span class="ml-5"
                            [ngClass]="{'span-disabled' : !normGradesCodes || normGradesCodes.length == 0}">Custom</span>
                    </div>

                    <teiasoft-select [emitOnDefaultInit]="false" *ngIf="!otherLimitationFreeInput"
                        [labelText]="'enquiryBook.otherLimitation' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [optionsList]="otherLimitationOptionList!"
                        [spaceLabel]="true"
                        [disabled]="!normGradesCodes || normGradesCodes.length == 0 || !otherLimitationOptionList || otherLimitationOptionList.length == 0"
                        [noMinWidth]="false" [isValid]="otherLimitationIsValid" [defaultValue]="otherLimitationValue"
                        (onSelected)="onSelectedOtherLimitation($event)" [readOnly]="false"></teiasoft-select>
                    <teiasoft-input *ngIf="otherLimitationFreeInput" [type]="'text'"
                        [labelText]="'enquiryBook.otherLimitation' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [value]="otherLimitationValue" [noMinWidth]="true"
                        (onInput)="onInputOtherLimitation($event)" [isValid]="otherLimitationIsValid"
                        [disabled]="!normGradesCodes || normGradesCodes.length == 0" [readOnly]="false"
                        [maxLength]="200"></teiasoft-input>
                    <div class="chk-cnt">
                        <i *ngIf="!otherLimitationFreeInput && (normGradesCodes && normGradesCodes.length > 0)"
                            class="fal fa-square chk-limitation" (click)="onCheckOtherLimitation()"></i>
                        <i *ngIf="otherLimitationFreeInput && (normGradesCodes && normGradesCodes.length > 0)"
                            class="fas fa-check-square chk-limitation" (click)="onCheckOtherLimitation()"></i>
                        <i *ngIf="!normGradesCodes || normGradesCodes.length == 0"
                            class="fal fa-square chk-disabled"></i>
                        <span class="ml-5"
                            [ngClass]="{'span-disabled' : !normGradesCodes || normGradesCodes.length == 0}">Custom</span>
                    </div>

                    <teiasoft-input class="grid-item" [type]="'text'" [labelText]="'grid.RawMaterialGrade' | translate"
                        [isMobile]="isMobile" [isRequired]="rawMaterialGradeIsRequired"
                        [disabled]="rawMaterialGradeDisabled" [value]="rawMaterialGradeValue" [showCreate]="false"
                        [autoComplete]="true" [autoCompleteDataset]="rawMaterialGradeDataset"
                        [autoCompleteColumns]="columnsRawMaterialGrades"
                        [autoCompleteColumnsToHide]="columnsToHideRawMaterialGrades"
                        [autoCompleteField]="'rawMaterialGrades'" [columnsWidthPerc]="[100]"
                        [isValid]="rawMaterialGradeIsValid" (onAutocompleteSelect)="onAutocompleteSelect($event)"
                        (onAutocompleteInputChange)="onAutocompleteInputChange($event)"
                        [readOnly]="false"></teiasoft-input>

                    <div class="grid-item " style="display: flex;align-items: flex-start;">
                        <teiasoft-toolbar [buttonsList]="toolbarButtonsList!" [theme]="theme!"
                            (onBtnClick)="onBtnToolbarClick($event)" style="margin-top:2vh;"></teiasoft-toolbar>
                    </div>
                    <div class="grid-item" *ngIf="npsIsrequired">
                        <teiasoft-input [type]="'text'" [labelText]="'grid.NpsDescription' | translate"
                            [isMobile]="isMobile" [isRequired]="npsIsrequired" [disabled]="npsDisabled"
                            [value]="npsValue" [readOnly]="npsIsReadOnly" [isValid]="npsIsValid"></teiasoft-input>

                    </div>
                    <teiasoft-input class="grid-item" [type]="'number'" [labelText]="getMeasureLabel('Od')"
                        [isMobile]="isMobile" [isRequired]="odIsRequired" [disabled]="false" [value]="odValue"
                        (onInput)="onInputOd($event)" (focusout)="onInputOdFocusOut($event)" [isValid]="odIsValid"
                        [readOnly]="odReadOnly" [roundDigits]="getRoundDigits('od')"
                        [limitDecimalDigits]="true"></teiasoft-input>

                    <div class="grid-item tol-container">
                        <!-- OD TOLERANCE PLUS -->
                        <!-- OD TOLERANCE MINUS -->
                        <teiasoft-input [type]="'number'" [labelText]="'grid.OdTolerancePlus' | translate"
                            [isMobile]="isMobile"
                            [isRequired]="hasAnyToleranceValue(odToleranceMinusValue, odTolerancePlusValue)"
                            [disabled]="!isFinite(odValue)" [value]="odTolerancePlusValue" style="width:49.5%"
                            (onInput)="onInputOdTolerancePlus($event)" [isValid]="odTolerancePlusIsValid"
                            [noMinWidth]="true" [readOnly]="false" startIcon="fal fa-arrow-up"
                            [roundDigits]="getRoundDigits('tolerancePlus')"></teiasoft-input>
                        <teiasoft-input [type]="'number'" [labelText]="'grid.OdToleranceMinus' | translate"
                            [isMobile]="isMobile"
                            [isRequired]="hasAnyToleranceValue(odToleranceMinusValue, odTolerancePlusValue)"
                            [disabled]="!isFinite(odValue)" [value]="odToleranceMinusValue" style="width:49.5%"
                            (onInput)="onInputOdToleranceMinus($event)" [isValid]="odToleranceMinusIsValid"
                            [noMinWidth]="true" [readOnly]="false" startIcon="fal fa-arrow-down"
                            [roundDigits]="getRoundDigits('toleranceMinus')"></teiasoft-input>
                    </div>
                    <div class="grid-item">
                        <!-- OD TOLERANCE UOM -->
                        <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                            [labelText]="'grid.OdToleranceUom' | translate" [isMobile]="isMobile"
                            [isRequired]="hasAnyToleranceValue(odToleranceMinusValue, odTolerancePlusValue)"
                            [disabled]="!isFinite(odValue)" [optionsList]="toleranceUomOptionList" [spaceLabel]="true"
                            [noMinWidth]="false" [isValid]="odToleranceUomIsValid" [defaultValue]="odToleranceUomValue"
                            (onSelected)="onSelectedOdToleranceUom($event)"
                            [readOnly]="odToleranceUomReadOnly"></teiasoft-select>
                    </div>
                    <teiasoft-input class="grid-item" [type]="'number'" [labelText]="getMeasureLabel('Id')"
                        [isMobile]="isMobile" [isRequired]="idIsRequired" [disabled]="idIsDisabled" [value]="idValue"
                        (onInput)="onInputId($event)" (focusout)="onInputIdFocusOut($event)" [isValid]="idIsValid"
                        [readOnly]="idReadOnly" [roundDigits]="getRoundDigits('id')"
                        [limitDecimalDigits]="true"></teiasoft-input>

                    <div class="grid-item tol-container">
                        <!-- ID TOLERANCE PLUS -->
                        <!-- ID TOLERANCE MINUS -->
                        <teiasoft-input [type]="'number'" [labelText]="'grid.IdTolerancePlus' | translate"
                            [isMobile]="isMobile"
                            [isRequired]="hasAnyToleranceValue(idToleranceMinusValue, idTolerancePlusValue)"
                            [disabled]="!isFinite(idValue)" [value]="idTolerancePlusValue" style="width:49.5%"
                            (onInput)="onInputIdTolerancePlus($event)" [isValid]="idTolerancePlusIsValid"
                            [noMinWidth]="true" [readOnly]="false" startIcon="fal fa-arrow-up"
                            [roundDigits]="getRoundDigits('tolerancePlus')"></teiasoft-input>
                        <teiasoft-input [type]="'number'" [labelText]="'grid.IdToleranceMinus' | translate"
                            [isMobile]="isMobile"
                            [isRequired]="hasAnyToleranceValue(idToleranceMinusValue, idTolerancePlusValue)"
                            [disabled]="!isFinite(idValue)" [value]="idToleranceMinusValue" style="width:49.5%"
                            (onInput)="onInputIdToleranceMinus($event)" [isValid]="idToleranceMinusIsValid"
                            [noMinWidth]="true" [readOnly]="false" startIcon="fal fa-arrow-down"
                            [roundDigits]="getRoundDigits('toleranceMinus')"></teiasoft-input>
                    </div>

                    <div class="grid-item">
                        <!-- ID TOLERANCE UOM -->
                        <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                            [labelText]="'grid.IdToleranceUom' | translate" [isMobile]="isMobile"
                            [isRequired]="hasAnyToleranceValue(idToleranceMinusValue, idTolerancePlusValue)"
                            [disabled]="!isFinite(idValue)" [optionsList]="toleranceUomOptionList" [spaceLabel]="true"
                            [noMinWidth]="false" [isValid]="idToleranceUomIsValid" [defaultValue]="idToleranceUomValue"
                            (onSelected)="onSelectedIdToleranceUom($event)"
                            [readOnly]="idToleranceUomReadOnly"></teiasoft-select>
                    </div>
                    <!-- LAYOUT PLACEHOLDER -->
                    <div class="grid-item" *ngIf="!npsIsrequired"></div>

                    <teiasoft-input [type]="'number'" [labelText]="getMeasureLabel('Wt')" [isMobile]="isMobile"
                        [isRequired]="wtIsRequired" [disabled]="false" [value]="wtValue" (onInput)="onInputWt($event)"
                        (focusout)="onInputWtFocusOut($event)" [isValid]="wtIsValid" [readOnly]="wtReadOnly"
                        [roundDigits]="getRoundDigits('wt')" [limitDecimalDigits]="true"></teiasoft-input>

                    <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.TypeOfTolerance' | translate"
                        [isMobile]="isMobile" [isRequired]="wtValue" [disabled]="!isFinite(wtValue)"
                        [optionsList]="typeOfToleranceOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="typeOfToleranceIsValid" [defaultValue]="typeOfToleranceValue"
                        (onSelected)="onSelectedTypeOfTolerance($event)" [readOnly]="false"></teiasoft-select>

                    <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.TubeExecution' | translate"
                        [isMobile]="isMobile" [isRequired]="false" [disabled]="!isFinite(wtValue)"
                        [optionsList]="tubeExecutionOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="tubeExecutionIsValid" [defaultValue]="tubeExecutionValue"
                        (onSelected)="onSelectedTubeExecution($event)" [readOnly]="false"></teiasoft-select>

                    <div class="tol-container">
                        <teiasoft-input [type]="'number'" [labelText]="'grid.WtTolerancePlus' | translate"
                            [isMobile]="isMobile" [isRequired]="isFinite(wtValue) && tubeExecutionValue"
                            [disabled]="!isFinite(wtValue) || tubeExecutionValue != 1"
                            [value]="tubeExecutionValue?wtTolerancePlusValue: ''" style="width:49.5%"
                            (onInput)="onInputTolerancePlus($event)" [isValid]="wtTolerancePlusIsValid"
                            [noMinWidth]="true" [readOnly]="false" startIcon="fal fa-arrow-up"
                            [roundDigits]="getRoundDigits('tolerancePlus')"></teiasoft-input>
                        <teiasoft-input [type]="'number'" [labelText]="'grid.WtToleranceMinus' | translate"
                            [isMobile]="isMobile" [isRequired]="isFinite(wtValue) && tubeExecutionValue"
                            [disabled]="!isFinite(wtValue) || tubeExecutionValue != 1"
                            [value]="tubeExecutionValue? wtToleranceMinusValue : ''" style="width:49.5%"
                            (onInput)="onInputToleranceMinus($event)" [isValid]="wtToleranceMinusIsValid"
                            [noMinWidth]="true" [readOnly]="false" startIcon="fal fa-arrow-down"
                            [roundDigits]="getRoundDigits('toleranceMinus')"></teiasoft-input>
                    </div>
                    <teiasoft-select [emitOnDefaultInit]="false" class="grid-item"
                        [labelText]="'grid.WtToleranceUom' | translate" [isMobile]="isMobile"
                        [isRequired]="isFinite(wtValue) && tubeExecutionValue"
                        [disabled]="!isFinite(wtValue) || tubeExecutionValue != 1"
                        [optionsList]="toleranceUomOptionList" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="wtToleranceUomIsValid" [defaultValue]="tubeExecutionValue?wtToleranceUomValue:''"
                        (onSelected)="onSelectedWtToleranceUom($event)"
                        [readOnly]="wtToleranceUomReadOnly"></teiasoft-select>
                    <!-- </div> -->
                    <!-- <div class="dialog-row"> -->
                    <div class="grid-container grid-row">

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.LengthType' | translate"
                            [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                            [optionsList]="lengthTypeOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="lengthTypeIsValid" [defaultValue]="lengthTypeValue"
                            (onSelected)="onSelectedLengthType($event)" [readOnly]="false"></teiasoft-select>

                        <ng-container *ngIf="lengthTypeValue === 'FL'">
                            <teiasoft-input [type]="'number'" [labelText]="getMeasureLabel('Length')"
                                [isMobile]="isMobile" [isRequired]="nominalLengthIsRequired" [disabled]="false"
                                [value]="nominalLengthValue" (onInput)="onInputNominalLength($event)"
                                [isValid]="nominalLengthIsValid" [readOnly]="false" [noMinWidth]="true"
                                [roundDigits]="getRoundDigits('lengthMin')"></teiasoft-input>
                            <div>
                                <div class="chk-cnt" style="flex-direction: row;">
                                    <i *ngIf="!multipleLengthValue" class="fal fa-square chk-limitation"
                                        (click)="onCheckMultipleLength()"></i>
                                    <i *ngIf="multipleLengthValue" class="fas fa-check-square chk-limitation"
                                        (click)="onCheckMultipleLength()"></i>
                                    <span class="ml-5">{{'grid.MultipleLength' | translate}}</span>
                                </div>
                            </div>


                        </ng-container>

                        <ng-container
                            *ngIf="lengthTypeValue === 'RL' || (lengthTypeValue === 'FL' && multipleLengthValue!!)">
                            <teiasoft-input [type]="'number'" [labelText]="getMeasureLabel('LengthMin')"
                                [isMobile]="isMobile" [isRequired]="lengthMinIsRequired" [disabled]="false"
                                [value]="lengthMinValue" (onInput)="onInputLengthMin($event)"
                                [isValid]="lengthMinIsValid" [readOnly]="false"
                                [roundDigits]="getRoundDigits('lengthMin')"></teiasoft-input>

                            <teiasoft-input [type]="'number'" [labelText]="getMeasureLabel('LengthMax')"
                                [isMobile]="isMobile" [isRequired]="lengthMaxIsRequired" [disabled]="false"
                                [value]="lengthMaxValue" (onInput)="onInputLengthMax($event)"
                                [isValid]="lengthMaxIsValid" [readOnly]="false"
                                [roundDigits]="getRoundDigits('lengthMax')"></teiasoft-input>
                        </ng-container>


                        <!-- <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.LengthUom' | translate" [isMobile]="isMobile"
                            [isRequired]="true" [disabled]="false" [optionsList]="lengthUomOptionList!"
                            [spaceLabel]="true" [noMinWidth]="false" [isValid]="lengthUomIsValid"
                            [defaultValue]="lengthUomValue" (onSelected)="onSelectedLengthUom($event)"
                            [readOnly]="false"></teiasoft-select> -->

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.UBent' | translate"
                            [isMobile]="isMobile" [isRequired]="true" [disabled]="true" [optionsList]="uBentOptionList!"
                            [spaceLabel]="true" [noMinWidth]="false" [isValid]="uBentIsValid"
                            [defaultValue]="uBentValue" (onSelected)="onSelectedUBent($event)"
                            [readOnly]="true"></teiasoft-select>


                        <div *ngIf="lengthTypeValue === 'RL' || (lengthTypeValue === 'FL' && !multipleLengthValue)">
                        </div>
                        <teiasoft-input class="grid-item span-2" [type]="'text'" [labelText]="'grid.Remark' | translate"
                            [value]="remarkValue" [isMobile]="isMobile" [isRequired]="false" [disabled]="false"
                            [isValid]="true" [readOnly]="false" (onInput)="onInputRemark($event)"
                            [ngClass]="{'span-3': lengthTypeValue === 'RL' || (lengthTypeValue === 'FL' && !multipleLengthValue) }"></teiasoft-input>
                    </div>
                    <!-- </div> -->
                    <!-- TOTAL WEIGHT -->
                    <!-- <div class="dialog-row"> -->
                    <teiasoft-input [type]="'number'" [labelText]="'grid.Quantity' | translate" [isMobile]="isMobile"
                        [isRequired]="true" [disabled]="false" [value]="quantityValue" style="margin-left: 0%;"
                        (onInput)="onInputQuantity($event)" [isValid]="quantityIsValid" [readOnly]="false"
                        [roundDigits]="getRoundDigits('quantity')"></teiasoft-input>

                    <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'enquiryBook.QuantityUom' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                        [optionsList]="quantityUomOptionList" [disableOptionSort]="true" [spaceLabel]="true"
                        [noMinWidth]="false" [isValid]="quantityUomIsValid" [defaultValue]="quantityUomValue"
                        (onSelected)="onSelectedQuantityUom($event)" [readOnly]="false"></teiasoft-select>

                    <div style="position: relative;">
                        <teiasoft-input [type]="'text'" [labelText]="'grid.TotalWeight' | translate"
                            [isMobile]="isMobile" [disabled]="true" [value]="totalWeightValue"
                            (onInput)="onInputTotalWeight($event)" [isValid]="totalWeightIsvalid" [readOnly]="false">
                        </teiasoft-input>
                        <button type="button" class="weight-button" (click)="calculateWeight()"><i
                                class="fa-weight-hanging fal"></i></button>
                    </div>

                    <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.TotalWeightUom' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                        [optionsList]="totalWeightUomOptionList" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="totalWeightUomIsValid" [defaultValue]="totalWeightUomValue"
                        (onSelected)="onSelectedTotalWeightUom($event)" [readOnly]="false"></teiasoft-select>


                    <!-- </div> -->
                    <!-- <div class="dialog-row"> -->
                    <div></div>
                    <teiasoft-input class="span-2" [type]="'text'" [labelText]="'grid.Mill' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="false" [value]="millValue"
                        [showCreate]="false" [autoComplete]="true" [autoCompleteDataset]="millDataset"
                        [autoCompleteColumns]="columnsMill" [autoCompleteColumnsToHide]="columnsToHideMill"
                        [autoCompleteField]="'mill'" [columnsWidthPerc]="[100]" [isValid]="millIsValid"
                        (onAutocompleteSelect)="onAutocompleteSelect($event)"
                        (onAutocompleteInputChange)="onAutocompleteInputChange($event)"
                        [readOnly]="false"></teiasoft-input>
                    <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.SurfaceType' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                        [optionsList]="surfaceTypeOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                        [isValid]="surfaceTypeIsValid" [defaultValue]="surfaceTypeValue"
                        (onSelected)="onSelectedsurfaceType($event)" [readOnly]="false"></teiasoft-select>

                    <div class="grid-container grid-row">

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.Cts' | translate"
                            [isMobile]="isMobile" [isRequired]="true" [disabled]="false" [optionsList]="ctsOptionList!"
                            [spaceLabel]="true" [noMinWidth]="false" [isValid]="ctsIsvalid" [defaultValue]="ctsValue"
                            (onSelected)="onSelectedCts($event)" [readOnly]="false"></teiasoft-select>

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.EndsCondition' | translate"
                            [isMobile]="isMobile" [isRequired]="true" [disabled]="!!ctsValue"
                            [optionsList]="endsConditionOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="endsConditionIsvalid" [defaultValue]="endsConditionValue"
                            (onSelected)="onSelectedEndsCondition($event)" [readOnly]="false"></teiasoft-select>

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.TestCondition' | translate"
                            [isMobile]="isMobile" [isRequired]="false" [disabled]="false"
                            [optionsList]="testConditionOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="testConditionIsvalid" [defaultValue]="testConditionValue"
                            (onSelected)="onSelectedTestCondition($event)" [readOnly]="false"></teiasoft-select>
                        <!-- </div> -->
                        <!-- <div class="dialog-row"> -->
                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.Ut' | translate"
                            [isMobile]="isMobile" [isRequired]="false" [disabled]="!!ctsValue"
                            [optionsList]="utOptionList!" [spaceLabel]="true" [noMinWidth]="false" [isValid]="utIsValid"
                            [defaultValue]="utValue" (onSelected)="onSelectedUt($event)"
                            [readOnly]="false"></teiasoft-select>

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.HydroTest' | translate"
                            [isMobile]="isMobile" [isRequired]="false" [disabled]="hydroTestDisabled"
                            [optionsList]="hydroTesttOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="hydroTestIsValid" [defaultValue]="hydroTestValue"
                            (onSelected)="onSelectedHydroTest($event)" [readOnly]="false"></teiasoft-select>

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.Ht' | translate"
                            [isMobile]="isMobile" [isRequired]="false" [disabled]="!!ctsValue"
                            [optionsList]="htOptionList!" [spaceLabel]="true" [noMinWidth]="false" [isValid]="htIsValid"
                            [defaultValue]="htValue" (onSelected)="onSelectedHt($event)"
                            [readOnly]="false"></teiasoft-select>

                        <teiasoft-select [emitOnDefaultInit]="false" [labelText]="'grid.HtAdditional' | translate"
                            [isMobile]="isMobile" [isRequired]="false" [disabled]="!!ctsValue"
                            [optionsList]="htAdditionalOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="htAdditionalIsValid" [defaultValue]="htAdditionalValue"
                            (onSelected)="onSelectedHtAdditional($event)" [readOnly]="false"></teiasoft-select>
                        <teiasoft-select class="sql-select" [emitOnDefaultInit]="false"
                            [labelText]="'grid.Sql' | translate" [isMobile]="isMobile" [isRequired]="true"
                            [disabled]="false" [optionsList]="sqlOptionList!" [spaceLabel]="true" [noMinWidth]="false"
                            [isValid]="sqlIsValid" [defaultValue]="sqlValue" (onSelected)="onSelectedSql($event)"
                            [readOnly]="false"></teiasoft-select>
                    </div>
                </div>
            </div>
            <div class="td-cnt-attach">
                <mat-accordion style="height: 100%;">
                    <mat-expansion-panel class="attachments-panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title> {{'enquiryBook.attachment' | translate}}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="attach-panel-dropzone" (dragover)="onDragOver($event)" (drop)="onDropFile($event)"
                            (dragleave)="onDragLeave($event)">
                            <div class="attach-panel-scroll">
                                <span
                                    *ngIf="(!items[selectedIndexItem].attachments || items[selectedIndexItem].attachments?.length == 0) && (!attachmentsToUpdate || attachmentsToUpdate.length == 0)"
                                    class="no-data">{{'enquiryBook.noData' | translate}}</span>

                                <!-- <span class="bold" style="font-size: 2.4vh;">
                            <i class="fal fa-paperclip mr-5"></i>{{'enquiryBook.attachment' | translate}}
                        </span> -->
                                <!-- <span
                            *ngIf="(!items[selectedIndexItem].attachments || items[selectedIndexItem].attachments!.length == 0)"
                            class="no-data">{{'enquiryBook.noData' | translate}}</span> -->
                                <!-- ATTACHMENTS OF THE ITEM -->
                                <div *ngIf="items[selectedIndexItem].attachments && items[selectedIndexItem].attachments!.length"
                                    class="cnt-attach">
                                    <div *ngFor="let item of items[selectedIndexItem].attachments" class="row-attach"
                                        [ngClass]="{'is-in-deletion' : isInDeletion(item.attachmentsId!)}">
                                        <span *ngIf="!item.presignedUrl! || item.presignedUrl! == ''"><i
                                                class="{{getFileIcoType(item)}} mr-5"></i>{{item.fileName}}</span>
                                        <span *ngIf="item.presignedUrl! && item.presignedUrl! != ''" class="attach-link"
                                            (click)="onOpenAttach(item)"><i
                                                class="{{getFileIcoType(item)}} mr-5"></i>{{item.fileName}}</span>
                                        <span>{{item.fileDate | date:globals.dateTimeFormat}}</span>
                                        <div *ngIf="!isInDeletion(item.attachmentsId!)" class="btn-delete-attach"
                                            (click)="onDeleteAttachClick(item)">
                                            <i class="fal fa-trash-alt mr-5"></i><span>{{'commons.delete' |
                                                translate}}</span>
                                        </div>
                                        <div *ngIf="isInDeletion(item.attachmentsId!)" class="btn-delete-attach"
                                            (click)="onCancelDeleteClick(item.attachmentsId!)">
                                            <i class="fal fa-times mr-5"></i><span>{{'commons.cancel' |
                                                translate}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- NEW ATTACHMENTS -->
                                <div *ngIf="attachmentsToUpdate && attachmentsToUpdate.length > 0" class="cnt-attach">
                                    <div *ngFor="let item of attachmentsToUpdate" class="row-attach">
                                        <span><i class="{{getFileIcoType(item)}} mr-5"></i>{{item.fileName}}</span>
                                        <span>{{item.fileCreationDate | date:globals.dateTimeFormat}}</span>
                                        <div class="btn-delete-attach" (click)="onDeleteAttachToUpdateClick(item)">
                                            <i class="fal fa-trash-alt mr-5"></i><span>{{'commons.delete' |
                                                translate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="isDragging" class="drop-zone-overlay">
                                <p>{{ 'commons.dropHere' | translate }}</p>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel [expanded]="true" style="overflow: auto;">
                        <mat-expansion-panel-header>
                            <mat-panel-title> {{'enquiryBook.deliveryExtras' | translate}} </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <section class="delivery-extras-section">
                            <mat-checkbox [(ngModel)]="dyePenetrantValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('dyePenetrant', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.DyePenetrant' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="dyePenetrant100PValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('dyePenetrant100P', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.DyePenetrant100P' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="penaltyValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('penalty', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.Penalty' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="colorCodingValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('colorCoding', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.ColorCoding' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="specialOperationsValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('specialOperations', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.SpecialOperations' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="specialTestsValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('specialTests', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.SpecialTests' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="grindingHoningValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('grindingHoning', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.GrindingHoning' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="ecValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('ec', $event)" [disabled]="!!ctsValue">
                                {{'grid.Ec' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="notStdPackagingValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('notStdPackaging', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.NotStdPackaging' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="inspectionType3Dot2Value"
                                (ngModelChange)="updateItemDeliveryExtraProperty('inspectionType3Dot2', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.InspectionType3Dot2' | translate}}
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="multipleCuttingValue"
                                (ngModelChange)="updateItemDeliveryExtraProperty('multipleCutting', $event)"
                                [disabled]="!!ctsValue">
                                {{'grid.MultipleCutting' | translate}}
                            </mat-checkbox>
                        </section>

                    </mat-expansion-panel>
                </mat-accordion>


            </div>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <input type="file" class="file-upload" (change)="onFileSelectedAttach($event)" style="display: none;"
                id="fileUploadAttach">
            <teiasoft-button (onClick)="onAddAttachmentClick()" class="mr-5" [type]="'tb-primary'"
                [text]="'commons.attachFile' | translate" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button *ngIf="action == 'create' || action == 'duplicate'" (onClick)="onAddItemClick()"
                class="mr-5" [type]="'tb-primary'" [text]="'commons.addAnotherItem' | translate" [theme]="theme"
                [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onSaveItemsClick()" class="mr-5" [type]="'tb-secondary'"
                [text]="'commons.save' | translate" [isMobile]="isMobile">
            </teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>

    <!-- MODAL SELECT NPS -->
    <app-modal-select-nps *ngIf="showSelectNps" [dataSet]="dataSetNps"
        [modalTitle]="'enquiryBook.selectNps' | translate" [columns]="columnsNps" [columnsToHide]="columnsToHideNps"
        [selectedRow]="selectedNpsRow" [columnsToFilter]="columnsToFilterNps"
        (onConfirmModalNps)="onConfirmModalNps($event)" [showDeleteSelection]="false"
        (onCloseModalNps)="onCloseModalNps($event)"></app-modal-select-nps>

    <!-- MODAL ATTACHMENT -->
    <!-- <app-modal-attach
    *ngIf="showSelectAttach"
    [attach]="selectedAttach"
    [isMobile]="isMobile"
    [theme]="theme"
    (closePreview)="showSelectAttach = false"
></app-modal-attach> -->